var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0654 14.5349V7.53491C20.0654 5.87806 18.7223 4.53491 17.0654 4.53491H7.06543C5.40858 4.53491 4.06543 5.87806 4.06543 7.53491V17.5349C4.06543 19.1918 5.40858 20.5349 7.06543 20.5349H13.5654M20.0654 14.5349L13.5654 20.5349M20.0654 14.5349H15.5654C14.4609 14.5349 13.5654 15.4303 13.5654 16.5349V20.5349",
    stroke: "#bd4c20",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.06543 8.53491H16.0654",
    stroke: "#bd4c20",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.06543 12.5349H12.0654",
    stroke: "#bd4c20",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.158d3ba0b48b2bad703787b2abf7ccc0.svg";
export { ForwardRef as ReactComponent };